module.exports = __webpack_public_path__ + "static/media/s_curling.60b3af39.mp3";